import { Box, ButtonSize, Icon, Text } from '@bechtel/gds';
import { ToolInventory, ToolOrderInventory } from '@bechtel/ht-types';
import { FC, useContext } from 'react';
import { ActionContent } from '~/components/action-content';
import { SecondaryButtonStyled } from '~/styles';
import { ReturnToolContext } from '../return-tool-context';
import { actionType } from '../types';
import { ToolCatalogMainItemStyled } from './item/styled';
import { ReturnToolSectionHeaderProps } from './type';

const ReturnToolSectionHeader: FC<ReturnToolSectionHeaderProps> = ({
  title,
  count,
  isOpen,
  setIsOpen,
  hideAllAction,
  hideCount,
  checkinToolList,
}) => {
  const arrowIcon = isOpen ? 'chevron-up' : 'chevron-down';
  const { updateData } = useContext(ReturnToolContext);

  const updateToolInventory = () => {
    let tempData: ToolInventory[] = [];
    if (checkinToolList && checkinToolList.length > 0) {
      checkinToolList.map((item: ToolOrderInventory) => tempData.push(item.toolInventory));
    }
    updateData(actionType.ADDLL, { checkInToolList: tempData });
  };
  return (
    <ToolCatalogMainItemStyled>
      <Box px={{ sm: '500' }} py={{ sm: '400' }}>
        <Box
          alignItems={{ sm: 'flex-start' }}
          pt={{ sm: '300' }}
          onClick={() => setIsOpen(!isOpen)}
          style={{ cursor: 'pointer' }}
        >
          <Icon icon={arrowIcon} iconStyle="duo" />
        </Box>
        <Box flexDirection={{ sm: 'column' }} justifyContent={{ sm: 'center' }} style={{ flex: '1' }}>
          <Box px={{ sm: '200' }}>
            <Text color="blue.800" weight="600" size="450" family={'openSans'}>
              {title} {count > 0 && !hideCount ? `(${count})` : ''}
            </Text>
          </Box>
        </Box>
        {!hideAllAction && (
          <SecondaryButtonStyled onClick={updateToolInventory} size={ButtonSize.SMALL}>
            <ActionContent icon="plus" label="Add All"></ActionContent>
          </SecondaryButtonStyled>
        )}
      </Box>
    </ToolCatalogMainItemStyled>
  );
};

export default ReturnToolSectionHeader;
